/* Obscura Mysteries: one-hint-at-a-time hints page.
   Hint and answer text is stored base64-encoded in data attributes so it
   isn't readable at a glance (or by search engines); this script decodes
   it only when a player asks for it. Progress is remembered in the
   player's own browser. */
(function () {
  'use strict';

  function decode(value) {
    if (!value) return '';
    try {
      var binary = window.atob(value);
      var bytes = new Uint8Array(binary.length);
      for (var i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
      return new TextDecoder().decode(bytes).trim();
    } catch (e) {
      return '';
    }
  }

  function load(key) {
    try {
      var raw = window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function save(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      /* storage unavailable: progress just isn't remembered */
    }
  }

  function OmHints(root) {
    this.root = root;
    this.inEditor = !!(window.Shopify && window.Shopify.designMode);
    this.mode = root.getAttribute('data-mode') || 'hints_answers';
    this.key = 'om-hints:' + window.location.pathname + ':' + (root.getAttribute('data-section') || '');
    var saved = (!this.inEditor && load(this.key)) || {};
    this.state = {
      part: 1,
      p2ok: !!saved.p2ok,
      topic: { 1: 0, 2: 0 },
      shown: saved.shown || {},
      answered: saved.answered || {},
      confirming: null
    };
    this.topics = { 1: [], 2: [] };
    this.bind();
    root.classList.add('is-ready');
    this.render(false);
  }

  OmHints.prototype.$ = function (selector) {
    return this.root.querySelector(selector);
  };

  OmHints.prototype.on = function (selector, handler) {
    var el = this.$(selector);
    if (el) el.addEventListener('click', handler.bind(this));
  };

  OmHints.prototype.bind = function () {
    var self = this;
    this.root.querySelectorAll('[data-topic]').forEach(function (btn) {
      var part = btn.getAttribute('data-part') === '2' ? 2 : 1;
      var index = self.topics[part].length;
      self.topics[part].push({
        btn: btn,
        id: btn.getAttribute('data-topic'),
        title: btn.getAttribute('data-title') || '',
        hints: [decode(btn.getAttribute('data-h1')), decode(btn.getAttribute('data-h2')), decode(btn.getAttribute('data-h3'))].filter(Boolean),
        answer: decode(btn.getAttribute('data-a'))
      });
      btn.addEventListener('click', function () {
        self.state.topic[part] = index;
        self.state.confirming = null;
        self.render(true);
      });
    });

    this.root.querySelectorAll('[data-part-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        self.state.part = tab.getAttribute('data-part-tab') === '2' ? 2 : 1;
        self.state.confirming = null;
        self.render(false);
      });
    });

    this.on('[data-unlock]', function () {
      this.state.p2ok = true;
      this.persist();
      this.render(false);
      var first = this.topics[2][0];
      if (first) first.btn.focus();
    });
    this.on('[data-back]', function () {
      this.state.part = 1;
      this.render(false);
      var tab = this.$('[data-part-tab="1"]');
      if (tab) tab.focus();
    });
    this.on('[data-next]', function () {
      var t = this.current();
      if (!t) return;
      var shown = Math.min(t.hints.length, (this.state.shown[t.id] || 0) + 1);
      this.state.shown[t.id] = shown;
      this.persist();
      this.render(false);
      var items = this.root.querySelectorAll('[data-hint-list] > li');
      if (items.length) items[items.length - 1].focus();
    });
    this.on('[data-ask]', function () {
      var t = this.current();
      if (!t) return;
      this.state.confirming = t.id;
      this.render(false);
      var yes = this.$('[data-yes]');
      if (yes) yes.focus();
    });
    this.on('[data-no]', function () {
      this.state.confirming = null;
      this.render(false);
      var ask = this.$('[data-ask]');
      if (ask) ask.focus();
    });
    this.on('[data-yes]', function () {
      var t = this.current();
      if (!t) return;
      this.state.answered[t.id] = true;
      this.state.confirming = null;
      this.persist();
      this.render(false);
      var answer = this.$('[data-answer]');
      if (answer) answer.focus();
    });
    this.on('[data-reset]', function () {
      var t = this.current();
      if (!t) return;
      delete this.state.shown[t.id];
      delete this.state.answered[t.id];
      this.state.confirming = null;
      this.persist();
      this.render(false);
      var next = this.$('[data-next]');
      if (next) next.focus();
    });
  };

  OmHints.prototype.current = function () {
    var list = this.topics[this.state.part];
    if (!list.length) return null;
    var i = Math.min(this.state.topic[this.state.part], list.length - 1);
    return list[i];
  };

  OmHints.prototype.persist = function () {
    if (this.inEditor) return;
    save(this.key, { p2ok: this.state.p2ok, shown: this.state.shown, answered: this.state.answered });
  };

  OmHints.prototype.selectBlock = function (blockId) {
    var self = this;
    [1, 2].forEach(function (part) {
      self.topics[part].forEach(function (t, i) {
        if (t.id === blockId) {
          self.state.part = part;
          self.state.topic[part] = i;
          if (part === 2) self.state.p2ok = true;
        }
      });
    });
    this.render(false);
  };

  OmHints.prototype.render = function (scrollToPanel) {
    var s = this.state;
    var root = this.root;
    var gate = s.part === 2 && !s.p2ok && this.topics[2].length > 0;

    root.querySelectorAll('[data-part-tab]').forEach(function (tab) {
      tab.setAttribute('aria-pressed', String(tab.getAttribute('data-part-tab') === String(s.part)));
    });
    root.querySelectorAll('[data-partsub]').forEach(function (el) {
      el.hidden = el.getAttribute('data-partsub') !== String(s.part);
    });
    root.querySelectorAll('[data-list]').forEach(function (el) {
      el.hidden = el.getAttribute('data-list') !== String(s.part);
    });

    this.$('[data-gate]').hidden = !gate;
    this.$('[data-layout]').hidden = gate;
    if (gate) return;

    var t = this.current();
    var panel = this.$('[data-panel]');
    var none = this.$('[data-none]');
    panel.hidden = !t;
    if (none) none.hidden = !!t;
    if (!t) return;

    var list = this.topics[s.part];
    var index = list.indexOf(t);
    list.forEach(function (topic) {
      var n = s.shown[topic.id] || 0;
      topic.btn.setAttribute('aria-pressed', String(topic === t));
      var status = topic.btn.querySelector('[data-status]');
      if (status) {
        status.textContent = s.answered[topic.id] ? 'Answered' : (n && topic.hints.length) ? n + ' of ' + topic.hints.length : '';
      }
    });

    var total = t.hints.length;
    var shown = Math.min(s.shown[t.id] || 0, total);
    var answered = !!s.answered[t.id];
    var confirming = s.confirming === t.id && !answered;

    this.$('[data-panel-title]').textContent = (index + 1) + '. ' + t.title;
    var answersOnly = this.mode === 'answers';
    var hintsOnly = this.mode === 'hints';
    this.$('[data-progress]').textContent = answersOnly ? '' : shown + ' of ' + total + ' hints shown';
    this.$('[data-empty]').hidden = answersOnly || shown > 0;

    var ol = this.$('[data-hint-list]');
    ol.textContent = '';
    for (var i = 0; i < shown; i++) {
      var li = document.createElement('li');
      li.className = 'om-hints__hint';
      li.tabIndex = -1;
      var label = document.createElement('p');
      label.className = 'om-hints__hint-label';
      label.textContent = 'Hint ' + (i + 1) + ' of ' + total;
      var text = document.createElement('p');
      text.className = 'om-hints__hint-text';
      text.textContent = t.hints[i];
      li.appendChild(label);
      li.appendChild(text);
      ol.appendChild(li);
    }

    var nextBtn = this.$('[data-next]');
    this.$('[data-more]').hidden = answersOnly || shown >= total;
    nextBtn.textContent = 'Show hint ' + (shown + 1);

    this.$('[data-ask-row]').hidden = hintsOnly || !(shown >= total && t.answer && !answered && !confirming);
    var note = this.$('[data-answers-note]');
    if (note) note.hidden = !(hintsOnly && total > 0 && shown >= total);
    this.$('[data-confirm]').hidden = !confirming;
    this.$('[data-answer]').hidden = !answered;
    this.$('[data-answer-text]').textContent = answered ? t.answer : '';
    this.$('[data-reset]').hidden = shown === 0 && !answered;

    if (scrollToPanel && window.matchMedia('(max-width: 989px)').matches) {
      panel.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-om-hints]').forEach(function (root) {
      if (!root.omHints) root.omHints = new OmHints(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest && event.target.closest('[data-om-hints]');
    if (root && root.omHints) root.omHints.selectBlock(event.detail.blockId);
  });
})();
